import { Controller } from "@hotwired/stimulus";
import colors from "tailwindcss/colors";

export default class extends Controller {
  static targets = ["select"];

  changeTheme(event) {
    const theme = event.target.value;
    document.body.style.setProperty("--primary-50", colors[theme][50]);
    document.body.style.setProperty("--primary-100", colors[theme][100]);
    document.body.style.setProperty("--primary-200", colors[theme][200]);
    document.body.style.setProperty("--primary-300", colors[theme][300]);
    document.body.style.setProperty("--primary-400", colors[theme][400]);
    document.body.style.setProperty("--primary-500", colors[theme][500]);
    document.body.style.setProperty("--primary-600", colors[theme][600]);
    document.body.style.setProperty("--primary-700", colors[theme][700]);
    document.body.style.setProperty("--primary-800", colors[theme][800]);
    document.body.style.setProperty("--primary-900", colors[theme][900]);
    document.body.style.setProperty("--primary-950", colors[theme][950]);
  }
}
